import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const mainContent = document.querySelector(".main-content");

    if (mainContent) {
      mainContent.scrollTo({
        top: 0,
        left: 0,
        behavior: "auto", // or "smooth"
      });
    }
  }, [pathname]);

  return null;
};

export default ScrollToTop;